<template lang="pug">
div
	template(v-if="isMobile")
		label#ccap-relationship-status-label.sr-only(for="news-theme-select-box-label") Témák
		VueSelect#knowledge-base-theme-select-box.knowledge-base-theme-select-box(label-id="news-theme-select-box-label", v-model="nativeSelectTheme", @input="select($event, true)")
			VueSelectOption(v-for="(tag, index) in tags", :text="tag.tag", :key="index", :index="index", :value="tag", :label-id="`news-theme-select-box-${index}`")
	nav.knowledge-base-theme.sf-card(v-if="!isMobile")
		h2.knowledge-base-theme__title Témák
		p#knowledge-base-theme__list-a11y.sr-only Ha csak egy adott témakör híreit szeretné megtekinteni, akkor az alábbi listából válassza ki az Önt érdeklő témakört!
		ul.knowledge-base-theme__list(aria-labelledby="news-theme__list-a11y")
			li.knowledge-base-theme__list-item(v-for="tag in tags")
				a.knowledge-base-theme__list-link(aria-labelledby="news-theme__list-text-hidden-a11y news-theme__list-text-a11y", :class="{ 'news-theme__list-link--active': selectedTag.tag == tag.tag }", @click.prevent="select(tag, true)")
					span#knowledge-base-theme__list-text-hidden-a11y.sr-only Aktuális téma:
					span#knowledge-base-theme__list-text-a11y.knowledge-base-theme__list-text
						| {{ tag.tag }}
						span.sr-only(aria-hidden="true") témában
</template>
<script>
import { mapState } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { VueSelect, VueSelectOption } from '@ui-common/vue-select';
import { isMobile } from '@ui-common/sf-js-utils';

export default {
	mixins: [isMobile],
	data() {
		return {
			nativeSelectTheme: {}
		};
	},
	props: {
		select: {
			type: Function,
			required
		}
	},
	components: {
		VueSelect,
		VueSelectOption
	},
	computed: {
		...mapState('knowledgeBaseModule', ['technicalError', 'loading', 'newsList', 'tags', 'selectedTag', 'allThemeTag'])
	},
	watch: {
		selectedTag(newValue) {
			this.nativeSelectTheme = newValue;
		}
	}
};
</script>
